export function getSentryRelease(): string {
  return process.env.REACT_APP_SENTRY_RELEASE || 'Development';
}
